import React from 'react';
import { IconWall, IconTag, IconKey, IconOut } from '../icons';

const VIEWS = [
  { id: 'home', label: 'Board', Icon: IconWall },
  { id: 'rewards', label: 'Rewards', Icon: IconTag },
  { id: 'admin', label: 'Grown-ups', Icon: IconKey },
];

export default function Nav({ view, setView, adminToken, logout }) {
  return (
    <nav className="nav" aria-label="Main">
      <p className="nav-brand">Token<br />Archive</p>

      <ul className="nav-items">
        {VIEWS.map(({ id, label, Icon }) => (
          <li key={id}>
            <button
              type="button"
              className="nav-link"
              aria-current={view === id ? 'page' : undefined}
              onClick={() => setView(id)}
            >
              <Icon />
              {label}
            </button>
          </li>
        ))}
      </ul>

      {adminToken && (
        <button
          type="button"
          className="nav-signout"
          onClick={logout}
          aria-label="Sign out of the grown-ups area"
        >
          <IconOut />
          <span className="nav-signout-text" aria-hidden="true">Sign out</span>
        </button>
      )}
    </nav>
  );
}
